import React from 'react';
import PropTypes from 'prop-types';

import { Layout } from '../../components';
import Spacing from '../Spacing/Spacing';
import Text from '../Text/Text';
import { IconListItem, IconListWrapper } from './style';

const CardIconList = ({ maxIconCount = 4, items = [], title }) => {
  const filteredItems = items.filter(item => Boolean(item));
  const showTitle = filteredItems.length === 1;
  const iconsList =
    filteredItems.length > maxIconCount
      ? filteredItems.slice(0, maxIconCount)
      : filteredItems;

  return (
    <Layout.Inline data-testid="CardIconList">
      {iconsList.map((item, key) => {
        return (
          <IconListWrapper
            key={key}
            showTitle={showTitle}
            data-testid="CardIcon"
          >
            <IconListItem>
              <React.Fragment>{item}</React.Fragment>
            </IconListItem>
            {showTitle && title ? (
              <Spacing left={2} responsive={false}>
                <Text type="boldBody">{title}</Text>
              </Spacing>
            ) : null}
          </IconListWrapper>
        );
      })}
    </Layout.Inline>
  );
};

CardIconList.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * array of image or svg element
   */
  items: PropTypes.array.isRequired,
  /**
   * maximum number of icons to show
   */
  maxItemCount: PropTypes.number,
  /**
   * title to dislay
   */
  title: PropTypes.string
};

export default CardIconList;
